import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: "Adversarial Neural Machine Translation (GAN Framework)",
      period: "Sep 2025 - Nov 2025 | CS4248",
      tags: ["PyTorch", "Transformers", "GANs", "LoRA", "RL", "NLP"],
      description: "Developed a GAN-based Chinese–English NMT system improving translation fluency. Built Seq2Seq and causal LM generators fine-tuned with LoRA. Applied SeqGAN-style adversarial RL combining discriminator rewards with BLEU-based hybrid rewards, achieving substantial gains over baselines."
    },
    {
      title: "AI Approaches in Games (AlphaZero-style)",
      period: "Oct 2025 - Nov 2025 | CS3263",
      tags: ["Python", "PyTorch", "Deep RL", "MCTS", "ResNet"],
      description: "Implemented an AlphaZero-style agent (policy–value ResNet + MCTS) trained via self-play for a simplified chess variant. Formulated the game as a Markov Decision Process, engineered compact board representations, and evaluated against random and alpha-beta agents."
    },
    {
      title: "HDB Resale Price Prediction (Multiple Linear Reg.)",
      period: "Sep 2025 - Nov 2025 | ST3131",
      tags: ["R", "Linear Regression", "Statistical Analysis", "EDA"],
      description: "Built a high-accuracy regression model to predict HDB resale prices (R² ≈ 0.88). Conducted comprehensive EDA, feature engineering, and rigorous model diagnostics (GVIF) to mitigate multicollinearity, identifying floor area and lease attributes as key drivers."
    },
    {
      title: "Verus – Agent-to-Agent Marketplace",
      period: "Oct 2025 | SingHacks Web3 Challenge",
      tags: ["Hackathon", "Architecture", "Smart Contracts", "Web3"],
      description: "Designed an agentic system architecture on the Hedera testnet using ERC-8004 for discovery/trust and x402 for on-chain payments. Enabled agent discovery, trust establishment, and automated settlement of gig tasks without human intervention.",
      link: "https://www.youtube.com/watch?v=qJ3Tpn5FQbI&feature=youtu.be",
      linkText: "Prototype Demo ↗"
    },
    {
      title: "Interest Rate Term Structure & Swap Analysis",
      period: "Oct 2024 - Nov 2024 | QF3101",
      tags: ["Quant Finance", "Financial Analysis", "Risk Management"],
      description: "Constructed 3-month SOFR implied term structures and FRA curves using market data ahead of the Nov 2024 Fed rate cut. Analyzed term premia, LIBOR curves post-GFC, and swap valuations to demonstrate interest rate hedging."
    },
    {
      title: "TuteeTally",
      period: "Jan 2024 - May 2024",
      tags: ["Java", "JavaFX", "Software Eng", "CLI"],
      description: "Developed a robust CLI and desktop application for private tutors to easily manage student particulars, exams, and payment data on-device, including summary statistics."
    },
    {
      title: "Study Buddy",
      period: "May 2023 - Aug 2023",
      tags: ["JavaScript", "React", "Mobile/Web", "Fullstack"],
      description: "Created an all-in-one productivity app with a to-do list, study timer, and assignment reminder. Designed a synchronized architecture where both a Web App and Mobile (Android) App share a common database to help students avoid procrastination."
    }
  ];

  return (
    <section id="projects" className="projects-section">
      <h2 className="section-title">Key Projects</h2>
      
      <div className="projects-grid">
        {projects.map((project, idx) => (
          <div key={idx} className="project-card glass-panel">
            <div className="project-content">
              <span className="project-period">{project.period}</span>
              <h3>{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              <div className="tags-container">
                {project.tags.map((tag, i) => (
                  <span key={i} className="project-tag">{tag}</span>
                ))}
              </div>
            </div>
            {project.link && (
              <div className="project-links">
                <a href={project.link} target="_blank" rel="noreferrer" className="github-link">
                  {project.linkText}
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
